<template>
  <div>
    <input
      v-show="false"
      accept="image/*"
      ref="inputUpload"
      type="file"
      @change="onFilePicked"
    />
    <v-card>
      <div class="container">
        <div class="row justify-content-start">
          <div class="col-5">
            <p class="title">{{ this.title }}</p>
          </div>
          <v-spacer></v-spacer>
          <v-btn :loading="uploadingImage" icon color="primary" @click="imageUploader">
            <v-icon> mdi-file-upload-outline</v-icon>
          </v-btn>
          <v-btn :loading="deletingImage" icon color="primary" @click="deleteImage">
            <v-icon> mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>

      <v-img
        v-if="preview"
        max-height="400"
        max-width="550"
        :src="imageUrl"
      ></v-img>
    </v-card>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  name: "ImageUpload",
  computed: {
    ...mapFields("shared", ["imagePath", "uploadingImage","deletingImage"]), 
  },
  data: () => ({
    image: null,
    imageUrl: "",
    preview: false,
    title: "Upload Image",
    imageName: "",
  }),
  methods: {
    ...mapActions("shared", ["uploadImage", "removeImage"]),
    imageUploader() {
      this.$refs.inputUpload.click();
      this.preview = true;
      this.title = "Preview";
    },
    async deleteImage() {
      this.preview = false;
 
      if (this.imageName) {
        await this.removeImage({
          payload: { 
            imageName: this.imageName, 
          },
        });
      }
      this.imageUrl = "";
      this.title = "Upload Image";
    },
    onFilePicked(event) {
      const files = event.target.files;
      const fileName = files[0].name;
      if (fileName.lastIndexOf(".") <= 0) {
        return alert("Please Enter a Valid File!");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];

      // Concatenate the image name with timestamp to ensure uniquuesness

      const currentDate = new Date();
      const timestamp = currentDate.getTime();
      this.imageName = fileName.split(".")[0] + timestamp;
      // get meta data from the image object

      const metadata = fileName.split(".")[1];
      if (this.image) {
        this.uploadImage({
          payload: {
            image: this.image,
            imageName: this.imageName,
            metadata: metadata,
          },
        });
      }
    },
  },
};
</script>